import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CandidateProfile } from 'src/app/public/app/models/candidateProfile';
import { CandidateAdditionalDetails } from 'src/app/core/models/candidateAdditionalDetails';
import { CandidateCardQueryFilter } from 'src/app/public/app/models/candidateCardQueryFilter';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { BsModalService } from 'ngx-bootstrap';
import {
  CandidateProfileActionsModalComponent
} from 'src/app/pages/mission-control-page/candidateprofile-page/candidate-profile-actions-modal/candidate-profile-actions-modal.component';

declare var libphonenumber: any;
declare var $: any;

@Component({
  selector: 'app-candidate-profile',
  templateUrl: './candidate-profile.component.html',
  styleUrls: ['./candidate-profile.component.css']
})
export class CandidateProfileComponent implements OnInit {
  @Input() candidateId: string;
  @Input() jobMatchId: string;
  @Input() context: string;
  @Input() documentInfo: any;
  @Input() hideResume: any;
  @Output() candidateContactDetailsMissingCallback = new EventEmitter<any>();

  candidate: any;
  phoneInConflictToolTipMessage = 'Phone Number in conflict.<br/> Update contact details.';
  phoneMissingToolTipMessage = 'Phone Number missing.<br/> Update contact details.';
  emailInConflictToolTipMessage = 'Email in conflict.<br/> Update contact details.';
  emailMissingToolTipMessage = 'Email missing.<br/> Update contact details.';
  resumeUrl: string;
  resumeReportPdfUrl: string;
  resumeDownloadPdfUrl: string;
  safeResumeReportPdfUrl: SafeResourceUrl;

  loadingFlag = true;
  skeletonPlaceholderRows = Array(4).fill(0);
  showProfileUrlFlag = false;
  showSalary = false;
  isCandidateProfileContactDetailsMissing = false;
  isCandidateProfileContactAdditionalDetailsMissing = false;
  isPdfGeneratedBySystem = false;
  activeTabIndex = 1;

  constructor(
    private authService: AuthService,
    private userRoleService: UserRoleService,
    private candidateService: CandidateService,
    private resumeService: ResumeService,
    private modalService: AngularModalService,
    private sharedService: SharedService,
    private bsModalService: BsModalService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.candidate = new CandidateProfile();
    this.resumeUrl = this.resumeService.getResumeDocumentUrl(this.candidateId);
    this.resumeReportPdfUrl = this.resumeService.getResumeDownloadPdfUrl(this.candidateId);
    this.resumeDownloadPdfUrl = this.resumeService.getResumeDownloadPdfUrl(this.candidateId);
    this.safeResumeReportPdfUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.resumeReportPdfUrl}#view=fitH`);

    this.loadingFlag = true;
    this.showProfileUrlFlag = false;
    this.showSalary = false;
    this.isCandidateProfileContactDetailsMissing = false;
    this.isCandidateProfileContactAdditionalDetailsMissing = false;
    this.isPdfGeneratedBySystem = false;

    this._getCandidateProfile();
  }

  private _getCandidateProfile(showLoading = true) {
    this.loadingFlag = showLoading;
    this.showProfileUrlFlag = false;
    this.candidateService.getCandidateProfile(this.candidateId, false, (data: any) => {
      this.candidate = { ...this.candidate, ...data };
      if (data.candidateAdditionalDetails) {
        this.candidate.candidateAdditionalDetails.workLocations = JSON.parse(JSON.stringify(data.candidateAdditionalDetails.workLocations || []));
      }
      this.candidate = this._massageCandidateData(this.candidate);
      this.candidate.profileUrlText = '';
      if (this.candidate.profileUrl !== null && this.candidate.profileUrl !== undefined) {
        this.showProfileUrlFlag = true;
        if (this.candidate.profileType !== 'Other') {
          this.candidate.profileUrlText = "View Candidate's " + this.candidate.profileType + ' Profile';
        } else {
          this.candidate.profileUrlText = "View Candidate's Profile";
        }
      }
      const userDetails = this.authService.getUserDetails();
      if (this.candidate.candidateCompanyId === userDetails.company.companyId && !this.userRoleService.isLoggedInUserEmployee()) {
        this.showSalary = true;
      }
      this._checkIfContactDetailsMissing();
      if (this.candidate.resume) {
        this.isPdfGeneratedBySystem = this.candidate.resume.isPdfGeneratedBySystem;
      }
      const filterParams = new CandidateCardQueryFilter(userDetails.company.companyId, userDetails.id);
      this.candidateService.getCandidateCard(this.candidateId, userDetails.id, filterParams, (cardData: any) => {
        this.candidate.totalExperience = cardData.totalExperience;
        this.loadingFlag = false;
      }, () => {
        this.loadingFlag = false;
      });
    }, (error: any) => {
      console.log('candidate get error - ', error);
      // do nothing.
    });
  }

  private _massageCandidateData(candidate: any) {
    candidate.name = candidate.firstName + ' ' + candidate.lastName;
    ['educations', 'experiences', 'technicalSkills', 'operationalSkills', 'softSkills', 'extraSkills', 'certifications', 'compensations']
      .forEach((listName: string) => {
        candidate[listName] = candidate[listName] || [];
      });
    if (candidate.title === null) {
      candidate.title = '-';
    }
    if (candidate.email === null) {
      candidate.email = '-';
    }
    if (candidate.mobilePhone === null) {
      candidate.mobilePhone = '-';
    }
    if (candidate.candidateAdditionalDetails === null || candidate.candidateAdditionalDetails === undefined) {
      candidate.candidateAdditionalDetails = new CandidateAdditionalDetails();
    }
    candidate.candidateAdditionalDetails.candidateId = this.candidateId;

    candidate.displayAddress1 = '';
    candidate.displayAddress2 = '';
    if (candidate.address === null || candidate.address === undefined) {
      candidate.displayAddress1 = '-';
      candidate.displayAddress2 = '-';
    } else {
      candidate.displayAddress1 += candidate.address.address1 === null ? '' : candidate.address.address1;
      candidate.displayAddress1 += candidate.address.address2 === null ? '' : ', ' + candidate.address.address2;
      candidate.displayAddress2 += candidate.address.city === null ? '' : candidate.address.city;
      candidate.displayAddress2 += candidate.address.county === null ? '' : ', ' + candidate.address.county;
      candidate.displayAddress2 += candidate.address.municipality === null ? '' : ', ' + candidate.address.municipality;
      candidate.displayAddress2 += candidate.address.state === null ? '' : ', ' + candidate.address.state;
      candidate.displayAddress2 += candidate.address.region === null ? '' : ', ' + candidate.address.region;
      candidate.displayAddress2 += candidate.address.county === null ? '' : ', ' + candidate.address.country;
      candidate.displayAddress2 += candidate.address.zipcode === null ? '' : ', ' + candidate.address.zipcode;
    }

    if (candidate.mobilePhoneCountryCodePresent) {
      const phoneNumberObject = libphonenumber.parse(candidate.mobilePhone.toString());
      if (phoneNumberObject.phone !== undefined) {
        candidate.mobilePhone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
      }
    }

    (candidate.educations || []).forEach((education: any) => {
      if (!education.instituteName) {
        education.instituteName = "'Unknown'";
      }
      if (education.startDate) {
        education.startDate.formattedMonth = this._getMonthByNumber(education.startDate.monthOfYear);
      }
      if (education.endDate) {
        education.endDate.formattedMonth = this._getMonthByNumber(education.endDate.monthOfYear);
      }
      this._setDateRange(education);
    });

    (candidate.experiences || []).forEach((experience: any) => {
      if (!experience.employerName) {
        experience.employerName = "'Unknown'";
      }
      if (experience.startDate) {
        experience.startDate.formattedMonth = this._getMonthByNumber(experience.startDate.monthOfYear);
      }
      if (experience.endDate) {
        experience.endDate.formattedMonth = this._getMonthByNumber(experience.endDate.monthOfYear);
      }
      this._setDateRange(experience);
    });

    candidate.isResumeFilePdf = false;
    if (candidate.resume && candidate.resume.fileName) {
      candidate.isResumeFilePdf = candidate.resume.fileName.slice(-4) === '.pdf';
    }

    return candidate;
  }

  private _setDateRange(experience: any) {
    experience.dateRange = '(';
    if (experience.startDate) {
      experience.dateRange = `${experience.dateRange}${experience.startDate.formattedMonth}, ${experience.startDate.year} -`;
    }
    if (experience.endDate) {
      experience.dateRange = `${experience.dateRange} ${experience.endDate.formattedMonth}, ${experience.endDate.year}`;
    } else {
      experience.dateRange = `${experience.dateRange}Current`;
    }
    experience.dateRange = `${experience.dateRange})`;
    if (!experience.startDate && !experience.endDate) {
      experience.dateRange = '';
    }
  }

  private _getMonthByNumber(monthNumber: number) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[monthNumber - 1];
  }

  private _checkIfContactDetailsMissing() {
    this.isCandidateProfileContactDetailsMissing = !this.sharedService.isContactDetailsAvailable(this.candidate, 'candidateCard');
    this.isCandidateProfileContactAdditionalDetailsMissing = !this.sharedService.isCandidateAdditionalDetailsAvailable(this.candidate);

    this.candidateContactDetailsMissingCallback.emit(
      this.isCandidateProfileContactDetailsMissing || this.isCandidateProfileContactAdditionalDetailsMissing
    );
  }

  saveCallback() {
    this._getCandidateProfile(false);
  }

  cancelCallback() {
    this._getCandidateProfile();
  }

  get showResumePdfTab(): boolean {
    return (this.context === 'candidateCard' || this.context === 'candidateJobMatchCard' ||
      this.context === 'candidateJobComparison' || this.context === 'conference') &&
      (this.isPdfGeneratedBySystem || this.candidate.isResumeFilePdf);
  }

  launchActionsModal(type: string) {
    let actionType = '';
    let actionLabel = '';
    switch (type) {
      case 'updateContact':
        actionType = 'updateContact';
        actionLabel = 'Update Candidate Contact Details';
        break;
      default:
        break;
    }
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      const candidateProfileActionsModal = this.bsModalService.show(CandidateProfileActionsModalComponent, {
        initialState: {
          actionType,
          actionLabel,
          candidateId: this.candidateId,
          reloadCandidateProfile: undefined
        },
        class: 'custom-candidate-profile-modal custom-modal-65'
      });

      candidateProfileActionsModal.content.onClose.subscribe((callbackObject: any) => {
        if (callbackObject && callbackObject.callbackType === 'refresh') {
          this._getCandidateProfile();
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    }, 300);
  }
}
